import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

export interface LarguraTela {
  celular: boolean;
  compacto: boolean;
}

export const useLarguraTela = (): LarguraTela => {
  const tema = useTheme();
  const celular = useMediaQuery(tema.breakpoints.down("xs"));
  const compacto = useMediaQuery(tema.breakpoints.down("md"));

  return { celular, compacto };
};

export default useLarguraTela;
